export default __webpack_public_path__ + "static/media/Background_00262.10f977d0.png";